import { render } from "./FlagsDetailedCard.vue?vue&type=template&id=17831058&scoped=true"
import script from "./FlagsDetailedCard.vue?vue&type=script&lang=js"
export * from "./FlagsDetailedCard.vue?vue&type=script&lang=js"

import "./FlagsDetailedCard.vue?vue&type=style&index=0&id=17831058&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17831058"]])

export default __exports__